import _Home from '@/components/homePage/Home';
import useAmplitude from '@/hooks/useAmplitude';

export const Home = () => {
  useAmplitude('home');
  return <_Home />;
};

export default Home;
